import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import { usePopoverContext } from '../context.esm.js';

var PopoverArrow = function PopoverArrow(props) {
  var _usePopoverContext = usePopoverContext(),
      getArrowProps = _usePopoverContext.getArrowProps,
      getArrowInnerProps = _usePopoverContext.getArrowInnerProps;

  var _getArrowProps = getArrowProps({
    shadowColor: 'rgb(0 0 0 / 10%)'
  }),
      arrowProps = _objectWithoutPropertiesLoose(_getArrowProps, ["translate"]);

  var _getArrowInnerProps = getArrowInnerProps(),
      arrowInnerProps = _objectWithoutPropertiesLoose(_getArrowInnerProps, ["translate"]);

  return React__default.createElement(Box, _extends({}, arrowProps), React__default.createElement(Box, _extends({
    backgroundColor: "bg-white"
  }, arrowInnerProps, props)));
};

if (__DEV__) {
  PopoverArrow.displayName = 'PopoverArrow';
}

export default PopoverArrow;
//# sourceMappingURL=index.esm.js.map
